export const styles = theme => ({
  root: {
    padding: 24,
    margin: 0,
  },
})
